import classNames from 'classnames';
import Image from 'next/image';
import { forwardRef } from 'react';

import { OnlinePaymentStep } from './business-hub-online-payment';
import styles from './business-hub-online-payment-step.module.scss';

interface Props extends OnlinePaymentStep {
    className?: string;
    contentClassName?: string;
}

const BusinessHubOnlinePaymentStepBase: React.ForwardRefRenderFunction<HTMLElement, Props> = (props, ref) => {
    const { name, description, icon, screenImage, illustration, illustrationRatio, className, contentClassName } = props;

    return (
        <section ref={ref} className={classNames(styles.container, className)}>
            <div className={classNames(styles.box, contentClassName)}>
                <div />
                <div className={styles.text}>
                    <div className={styles.icon}>
                        <div className={styles.box}>
                            <Image
                                src={icon}
                                alt=""
                                style={{ objectFit: 'contain', objectPosition: 'center' }}
                                fill
                                loader={({ src, width, quality }) => {
                                    return `${src}?width=${width}&quality=${quality ?? 75}&format=webp`;
                                }}
                            />
                        </div>
                    </div>
                    <div className={styles.title}>{name}</div>
                    <div className={styles.description} dangerouslySetInnerHTML={{ __html: description || '' }} />
                </div>
                <div className={styles.screenImage}>
                    {/* <Image
                        src={screenImage}
                        alt=""
                        style={{ objectFit: 'cover', objectPosition: 'center' }}
                        fill
                        loader={({ src, width, quality }) => {
                            return `${src}?width=${width}&quality=${quality ?? 75}`;
                        }}
                    /> */}
                </div>
                <div className={styles.illustration} style={{ '--data-ratio': `${illustrationRatio}` } as any}>
                    <Image
                        src={illustration}
                        alt=""
                        style={{ objectFit: 'cover', objectPosition: 'center' }}
                        fill
                        loader={({ src, width, quality }) => {
                            return `${src}?width=${width}&quality=${quality ?? 75}&format=webp`;
                        }}
                    />
                </div>
            </div>
        </section>
    );
};

const BusinessHubOnlinePaymentStep = forwardRef(BusinessHubOnlinePaymentStepBase);
BusinessHubOnlinePaymentStep.displayName = 'BusinessHubOnlinePaymentStep';

export { BusinessHubOnlinePaymentStep };
